<div v-if="model" @click.stop></div>